
export const getAuthConfig = {    
  "domain": process.env.REACT_APP_GS1_AUTH0_DOMAIN,
  "clientId": process.env.REACT_APP_GS1_AUTH0_CLIENTID,
  "audience": process.env.REACT_APP_GS1_AUTH0_AUDIENCE
};
